import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-login-create",
  templateUrl: "./login-create.component.html",
  styleUrls: ["./login-create.component.scss"],
})
export class LoginCreateComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {}

  back() {
    this.router.navigate(["/login/email"]);
  }

  gotoHostStart() {
    this.router.navigate(["/host/start"]);
  }

  gotoEventList() {
    this.router.navigate(["/events"]);
  }
}
